import LetterText from "./home/LetterText";
import Splash from "./splash/Splash";
import Login from "./login/Login";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import UserContextProvider from "./context/UserContextProvider";
import Register from "./register/Register";
import errorimg from "../src/assets/landscape-error.svg"
import './App.css'
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';


const Layout = () => {
  return (
    <>
      <div className="main-container">
        <Outlet />
      </div>
      <div className="error-img">
        <div className="error-text">
          <img src={errorimg} alt="" />
          <p>This game does not support on landscape mode, Please rotate your phone!</p>
          <p>
            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-alert-triangle" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#000000" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 9v4" />
              <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" />
              <path d="M12 16h.01" />
            </svg>Your game is running now!</p>
        </div>
      </div>
    </>
  )
}


const App = () => {
  return (
    <UserContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Login key={window.location.search} />} />
            <Route path="/splash" element={<Splash />} />
            <Route path="/register" element={<Register />} />
            <Route path="/letter-text" element={<LetterText />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </UserContextProvider>
  );
};

export default App;